export const fullPlazaNameLabel = 'IoT.ON Edge Plaza Name';
